// import React, { useState } from "react";
// import "./ResetPasswordForm.scss";
// import CustomTextBox from "../customTextBox/CustomTextBox";
// import CustomButton from "../customButton/CustomButton";
// import CustomGoBack from "../customGoBack/CustomGoBack";
// import { validateEmail } from "../login-form/LoginForm";
// import { ToastDisplayer } from "../toastDisplay/ToastDisplayer";
// import {
//   checkEmailExistsAndRole,
//   generateOtpWithAction,
// } from "../../api/forgotPwdApi";
// import { LoadPanel } from "devextreme-react";

// export default function ResetPasswordForm({ onContinue, onResetPwdGoBack }) {
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);
//   const handleContinue = async () => {
//     try {
//       const trimmedEmail = email.trim();
  
//       if (!trimmedEmail) {
//         return ToastDisplayer("error", "Email address cannot be empty.");
//       }
  
//       if (!validateEmail(trimmedEmail)) {
//         return ToastDisplayer("error", "Please enter a valid email address.");
//       }
  
//       setLoading(true);
//       const result = await checkEmailExistsAndRole(trimmedEmail);
      
//       if (!result?.data) {
//         throw new Error("Result not found");
//       }
  
//       const otpResult = await generateOtpWithAction(result.data.email, "R");
//       ToastDisplayer(
//         otpResult?.status === 200 ? "success" : "error",
//         otpResult?.status === 200 ? otpResult.data.message : "OTP generation failed"
//       );
  
//       onContinue(result.data.email, result.data.userrole);
//     } catch (error) {
//       ToastDisplayer("error", error.response?.data?.error || error.message);
//     } finally {
//       setLoading(false); 
//     }
//   };
  

//   return (
//     <>
//       {loading && <LoadPanel visible={true} />}
//       <CustomGoBack onGoBack={onResetPwdGoBack} />

//       <div className="resetHeader">Reset Password</div>
//       <div className="resetText">Type your email address to get an OTP</div>

//       <CustomTextBox
//         label="Email Address"
//         placeholder="Type your email address"
//         value={email}
//         onChange={(e) => setEmail(e.value)}
//         type="email"
//       />

//       <div className="mySpace">
//         <CustomButton text="Continue" onClick={handleContinue} />
//       </div>
//     </>
//   );
// }


// Rishab code
import React, { useEffect, useState } from "react";
import "./ResetPasswordForm.scss";
import CustomTextBox from "../customTextBox/CustomTextBox";
import CustomButton from "../customButton/CustomButton";
import CustomGoBack from "../customGoBack/CustomGoBack";
import { validateEmail } from "../login-form/LoginForm";
import { ToastDisplayer } from "../toastDisplay/ToastDisplayer";
import {
  checkEmailExistsAndRole,
  generateOtpWithAction,
} from "../../api/forgotPwdApi";
import { LoadPanel, TextBox } from "devextreme-react";
 
export default function ResetPasswordForm({ onContinue, onResetPwdGoBack }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const handleContinue = async () => {
    try {
      const trimmedEmail = email.trim();
     
      if (!trimmedEmail) {
        return ToastDisplayer("error", "Email address cannot be empty.");
      }
 
      if (!validateEmail(trimmedEmail)) {
        return ToastDisplayer("error", "Please enter a valid email address.");
      }
 
      setLoading(true);
      const result = await checkEmailExistsAndRole(trimmedEmail);
     
      if (!result?.data) {
        throw new Error("Result not found");
      }
 
      const otpResult = await generateOtpWithAction(result.data.email, "R");
      ToastDisplayer(
        otpResult?.status === 200 ? "success" : "error",
        otpResult?.status === 200 ? otpResult.data.message : "OTP generation failed"
      );
 
      onContinue(result.data.email, result.data.userrole);
    } catch (error) {
      ToastDisplayer("error", error.response?.data?.error || error.message);
    } finally {
      setLoading(false);
    }
  };
  //To Add Enter key functionality!
  const handleKeyDown = (e, name) => {
    e.stopPropagation();
    if (e.key === "Enter") {
      handleContinue();
      }
  };
 
 
  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <CustomGoBack onGoBack={onResetPwdGoBack} />
 
      <div className="resetHeader">Reset Password</div>
      <div className="resetText">Type your email address to get an OTP</div>
 
      <div className="MyTextBox">
          <div className="fieldsMain">
            <label className="TextBoxLabel" htmlFor="email">
              Email Address <span className="requiredClass">*</span>
            </label>
            <div className="TextBoxWrapper">
              <TextBox
                placeholder="Type your Email address"
                value={email}
                onValueChange={(e) => setEmail(e)}
                type="email"
                stylingMode="outlined"
                className="TextBoxMain"
                valueChangeEvent="keyup"
                onKeyDown={(e) => handleKeyDown(e.event, "email")}
              />
            </div>
          </div>
        </div>
 
      <div className="mySpace">
        <CustomButton text="Continue" onClick={handleContinue} />
      </div>
    </>
  );
}